import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Media from './components/Media';
import FAQ from './components/FAQ';
import Cards from './components/Cards';
import Features from './components/Features';
import Topics from './components/Topics';
import About from './components/About';
import Updates from './components/Updates';
import Comments from './components/Comments';
import AppEntry from './components/AppEntry';
import Contact from './components/Contact';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Media />
        <FAQ />
        <Cards />
        <Features />
        <Topics />
        <About />
        <Updates />
        <Comments />
        <AppEntry />
        <Contact />
        <Index />
        <Carousel />
      </main>
      <Footer />
    </div>
  );
}